import sessionsApi from '@/api/v1/sessions';

export default {
  namespaced: true,

  actions: {
    checkToken({ dispatch }, token) {
      return new Promise((resolve, reject) => {
        sessionsApi.password
          .check(token)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    recoverPassword({ dispatch }, email) {
      return new Promise((resolve, reject) => {
        sessionsApi.password
          .recover({ email })
          .then((resp) => {
            dispatch('showSuccess', ['Password reset link sent'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    updatePassword({ dispatch }, passwordData) {
      return new Promise((resolve, reject) => {
        sessionsApi.password
          .update(passwordData.token, {
            password: passwordData.password,
            password_confirmation: passwordData.password_confirmation,
          })
          .then((resp) => {
            dispatch('showSuccess', ['Password changed'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },
  },
};
